export const JobOrderQueryActions = {
  PlacementCreation: 'placementCreation',
  PlacementDetail: 'placementDetail',
  PlacementTab: 'placements'
};

export const buildPresentationMakerJobOrderParam = jobOrderData => {
  if (!jobOrderData || !jobOrderData?.id) return null;

  const { address, id, title, specialty, subspecialty, company } = jobOrderData || {};

  return {
    jobOrder: {
      id,
      title,
      industry: specialty?.industry?.title,
      specialty: specialty?.title,
      subspecialty: subspecialty?.title,
      state: address?.city?.state?.title,
      city: address?.city?.title,
      postalCode: address?.zip,
      companyName: company?.name,
      companyId: company?.id
    }
  };
};

export const buildJobOrderProspectingAssistantProps = profile => {
  if (!profile) return {};

  const { address, title, company } = profile;
  const { city: companyCity } = company || {};

  const jobOrderLocation = [address?.city?.title, address?.city?.state?.title]
    .filter(Boolean)
    .join(', ');
  const companyLocation = [companyCity?.title, companyCity?.state?.title]
    .filter(Boolean)
    .join(', ');

  return {
    title,
    location: jobOrderLocation || companyLocation
  };
};
